import { createAction } from "@reduxjs/toolkit";
export const newWidgetReceived = createAction("analyticsCopilotReducers/newWidgetReceived");
